import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import RequireAuth from "../components/requireAuth";
import Activity from "../pages/Activity";
import HourlyTracking from "../pages/HourlyTracking";
import Layout from "../pages/Layout";
import Mission from "../pages/Mission";
import SettingsCompanies from "../pages/SettingsCompanies";
import SettingsTeam from "../pages/SettingsTeam";
import SettingsTimeManagement from "../pages/SettingsTimeManagement";
import SettingsOrganization from "../pages/SettingsOrganization";
import Unauthorized from "../pages/Unauthorized";
import {
  ROLE_BIG_COMPANY_ADMIN,
  ROLES_COMPANY_SETTINGS_ACCESS,
} from "../constants/roles";

const ConnectionRoutes = () => {
  const navigate = useNavigate();

  const url = window.location.pathname;
  if (url === "/settings") {
    navigate("/settings/team");
  }

  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path={"hourly-tracking"} element={<HourlyTracking />} />
          <Route path={"hourly-tracking/:id"} element={<Mission />} />
          <Route element={<RequireAuth allowedRoles={ROLES_COMPANY_SETTINGS_ACCESS} />}>
            <Route path={"activity"} element={<Activity />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={ROLES_COMPANY_SETTINGS_ACCESS} />}>
            <Route path={"settings/team"} element={<SettingsTeam />} />
            <Route
              path={"settings/time-management"}
              element={<SettingsTimeManagement />}
            />
          </Route>
          <Route element={<RequireAuth allowedRoles={[ROLE_BIG_COMPANY_ADMIN]} />}>
            <Route
              path={"organization/settings"}
              element={<SettingsOrganization />}
            />
            <Route
              path={"organization/settings/companies"}
              element={<SettingsCompanies />}
            />
            <Route
              path={"settings/companies"}
              element={<Navigate to="/organization/settings/companies" replace />}
            />
            <Route
              path={"settings/organization"}
              element={<Navigate to="/organization/settings" replace />}
            />
          </Route>
          <Route path={"unauthorized"} element={<Unauthorized />} />
        </Route>
      </Routes>
    </>
  );
};

export default ConnectionRoutes;
